import { Capacitor } from "@capacitor/core";

/** True on Android — the native shell or an Android browser. */
export function isAndroid(): boolean {
  if (Capacitor.getPlatform() === "android") return true;
  return (
    typeof navigator !== "undefined" && /android/i.test(navigator.userAgent)
  );
}

/**
 * True on iOS — the native shell, or an iOS browser. iPadOS 13+ requests
 * desktop sites by default and reports a Mac user agent, so a Mac claiming
 * touch points is treated as an iPad.
 */
export function isIOS(): boolean {
  if (Capacitor.getPlatform() === "ios") return true;
  if (typeof navigator === "undefined") return false;
  if (/iPad|iPhone|iPod/i.test(navigator.userAgent)) return true;
  return /Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1;
}

/**
 * Whether to offer "Continue with Apple". Now true everywhere: Apple sign-in is
 * offered on Android as well as iOS, so an account created on an iPhone can be
 * signed back into from an Android device. Android has no native Apple handoff,
 * so it runs through the web OAuth flow.
 *
 * Kept as a function rather than deleted at the call sites so the decision stays
 * in one place if it ever needs re-gating.
 */
export function isAppleSignInAvailable(): boolean {
  return true;
}
